var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporatePayBillsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86395 9.09103H11.847M9.86395 12.514H17.932M9.86395 15.924H17.932M9.86395 19.346H17.932M15.514 22.022H17.932M24.465 4.27003H8.58695C7.80256 4.27214 7.0509 4.58468 6.49625 5.13933C5.9416 5.69398 5.62906 6.44564 5.62695 7.23003V27.564L7.29695 25.988L8.89995 27.51L10.42 26.07L12.024 27.592L13.694 26.016L15.406 27.633L17.103 26.03L18.843 27.66L20.513 26.084L22.251 27.728V6.47003C22.251 5.88642 22.4828 5.32672 22.8955 4.91404C23.3081 4.50137 23.8678 4.26953 24.4515 4.26953C25.0351 4.26953 25.5948 4.50137 26.0074 4.91404C26.4201 5.32672 26.652 5.88642 26.652 6.47003V7.78703H22.238",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporatePayBillsIcon);
export default __webpack_public_path__ + "static/media/corporatePayBillsIcon.e9c5acc8039b832fb1edd20c2df3ecdb.svg";
export { ForwardRef as ReactComponent };